import React from 'react';
import classnames from 'classnames';
import Panel from 'components/v2/panels/Panel';

export default function Card({
  children,
  className,
  header,
  footer,
  panelClassName,
}) {
  return (
    <div
      className={classnames(
        'divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow flex flex-col justify-between',
        className,
      )}
    >
      {header && header()}
      <Panel className={classnames(panelClassName, 'flex-1')}>{children}</Panel>
      {footer && footer()}
    </div>
  );
}
